import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import { prop } from 'ramda'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

import { withForm } from '~/components/Form'
import { Button, DiscardButton } from '~/components/Buttons'
import DialogTitle from '~/components/DialogTitle'
import TextField from '~/components/Fields/TextField'

function WarehouseDeleteDialog ({ open, handleClose, form, isLoading, name }) {
  const { t } = useTranslation()
  const { handleSubmit, values } = form

  const confirmation = prop('confirmation', values)

  return (
    <Dialog
      open={open}
      fullWidth={true}
      onClose={handleClose}
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          <Typography
            component="h2"
            variant="h6"
          >
            {`Are you sure, you want to delete warehouse ${name}?`}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ minHeight: '30vh', paddingTop: '10px !important' }}>
          <Grid container={true} spacing={1}>
            <Grid item={true} lg={12}>
              <Typography>{t('Type "DELETE" to confirm your action')}</Typography>
            </Grid>
            <Grid item={true} lg={12}>
              <TextField
                data-cy="confirmation"
                name="confirmation"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <DiscardButton
            onClick={handleClose}
            fullWidth={true}
          >
            Discard
          </DiscardButton>
          <Button
            variant="contained"
            fullWidth={true}
            type="submit"
            data-cy="done"
            disabled={confirmation !== 'DELETE' || isLoading}
          >
            Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

WarehouseDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  form: PropTypes.object,
  isLoading: PropTypes.bool,
  name: PropTypes.string,
}

export default withForm(WarehouseDeleteDialog)
